import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  champions: [],
  fetchLoading: false,
  singleChampion: null,
};

const slice = createSlice({
  name: "champion",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateChampionSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.champions = state.champions.map((champion) => {
        if (champion.id === action.payload.id) {
          return action.payload;
        }
        return champion;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getChampionSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.champions = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleChampionSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleChampion = action.payload;
    },

    // GET PRODUCTS
    createChampionSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.champions = [...state.champions, action.payload];
    },

    // DELETE EVENT
    deleteChampionSuccess(state, action) {
      const championId = action.payload;
      state.champions = state.champions.filter(
        (champion) => champion.id !== championId
      );
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getChampions() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("champions");
      dispatch(slice.actions.getChampionSuccess(response.data.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleChampion({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`champions/${id}`);
      dispatch(slice.actions.getSingleChampionSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createChampions({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("champions", data);
      dispatch(slice.actions.createChampionSuccess(response.data.data));
      enqueueSnackbar("Champion is added successfully");
      navigate(PATH_DASHBOARD.settings.champions.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateChampions({ id, data, enqueueSnackbar, setOpenEdit }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`champions/${id}`, data);
      dispatch(slice.actions.updateChampionSuccess(response.data.data));
      enqueueSnackbar("Champion is updated successfully");
      setOpenEdit && setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteChampion({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`champions/${id}`);
      dispatch(slice.actions.deleteChampionSuccess(id));
      enqueueSnackbar("Champion is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
